import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import {
  displayMarineValue,
  displayMarineValueWithUnit,
} from '../../../utils/marineForecast.utils';

export const route = 'getBuoyConditions';

export const buoyConditionDetails = [
  {
    id: 'windSpeed',
    label: 'Wind SP',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_SPEED,
    getValue: (entry) => displayMarineValueWithUnit(entry?.wind_speed, ' MPH'),
  },
  {
    id: 'dewPoint',
    label: 'Dew Point',
    iconKey: WEATHER_DETAIL_ICON_KEYS.DEW_POINT,
    getValue: (entry) => displayMarineValueWithUnit(entry?.dew_point, '\u00b0F'),
  },
  {
    id: 'wavePeriod',
    label: 'Wave Period',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TIME,
    getValue: (entry) => displayMarineValue(entry?.wave_period),
  },
  {
    id: 'waveHeight',
    label: 'Wave Height',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WAVE,
    getValue: (entry) => displayMarineValueWithUnit(entry?.wave_height, ' ft'),
  },
  {
    id: 'waterTemperature',
    label: 'Water Temp',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TEMPERATURE,
    getValue: (entry) => displayMarineValueWithUnit(entry?.water_temperature, '\u00b0F'),
  },
  {
    id: 'barometricPressure',
    label: 'Barometric Pressure',
    iconKey: WEATHER_DETAIL_ICON_KEYS.PRESSURE,
    getValue: (entry) => displayMarineValueWithUnit(entry?.baro_pressure, ' in'),
  },
  {
    id: 'airTemperature',
    label: 'Air Temp',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TEMPERATURE,
    getValue: (entry) => displayMarineValueWithUnit(entry?.air_temperature, '\u00b0F'),
  },
  {
    id: 'windDirection',
    label: 'Wind Direction',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_DIRECTION,
    getValue: (entry) => displayMarineValue(entry?.wind_short),
  },
  {
    id: 'visibility',
    label: 'Visibility',
    iconKey: WEATHER_DETAIL_ICON_KEYS.VISIBILITY,
    getValue: (entry) => displayMarineValueWithUnit(entry?.visibility, ' mi'),
  },
];
